document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-announcement-modal]');
  if (!modal) return;

  const storageKey = modal.dataset.modalKey || 'popup_shown';
  if (sessionStorage.getItem(storageKey) === 'true') return;

  const closeButtons = modal.querySelectorAll('.announcement-modal__overlay, .announcement-modal__close');
  const closeModal = () => {
    modal.setAttribute('hidden', 'hidden');
    sessionStorage.setItem(storageKey, 'true');
  };

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.removeAttribute('hidden');
});
